import React from 'react';
import { Redirect } from 'react-router-dom';
import { updateRoutes } from '@/pages/route-config';
import update from 'immutability-helper';
import { isEmpty } from 'lodash';
import NoPower from '@/components/nopower';

function showNoPowerPage(routeItem) {
  let resultArr = [
    Object.assign({}, routeItem, {
      hideInNav: true,
      component: () => <NoPower resCode={routeItem.menuCode} />,
    }),
  ];

  if (routeItem.menus || routeItem.dynamicChild || routeItem.dynamic) {
    // 如果有子路由，且本身路由的最后一个字符不为’*‘,则在后面加一个无权限兜底路由，让所有该路由下的子路由都只渲染无权限页面
    if (routeItem.path[routeItem.path.length - 1] !== '*') {
      const path = routeItem.path + (routeItem.path[routeItem.path.length - 1] === '/' ? '*' : '/*');
      resultArr.push({
        path: path,
        component: () => <NoPower resCode={routeItem.menuCode} />,
        hideInNav: true,
      });
    }
  }

  return resultArr;
}

/**
 ** 当noPowerVisible: true替换为无权限页面而不是过滤掉
 * @param {([{menuId:number | undefined,menuCode:string | undefined,parentId:number,parentCode:string | undefined}] | *)} fullRoutes
 * @param {{[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *}} allowedMenus
 * @param {{[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *}} [allowedMenusCode]
 * @returns
 */
export function filterDisabledRoutes(fullRoutes, allowedMenus, allowedMenusCode, noPowerVisible = true) {
  if (!allowedMenus || !fullRoutes) return;

  const _fullRoutes = [];
  const _noPowerRoutes = [];

  const mapAllowedMenus = allowedMenus;
  const mapAllowedMenusCode = allowedMenusCode || {};

  let routeItem = null;

  for (var i = 0, len = fullRoutes.length; i < len; i++) {
    // 前端路由没有menuId和code，不需要权限控制
    if (
      !fullRoutes[i].menuId &&
      !fullRoutes[i].menuCode &&
      fullRoutes[i].menuId !== 0 &&
      fullRoutes[i].menuCode !== 0
    ) {
      _fullRoutes.push(fullRoutes[i]);
      continue;
    }
    // 路由没有权限
    if (
      typeof mapAllowedMenus[fullRoutes[i].menuId] === 'undefined' &&
      typeof mapAllowedMenusCode[fullRoutes[i].menuCode] === 'undefined'
    ) {
      if (noPowerVisible && fullRoutes[i].path) {
        //无权限，有path，且展示，改成无权限页面加入
        // _fullRoutes.push(...showNoPowerPage(fullRoutes[i]));
        _noPowerRoutes.push(...showNoPowerPage(fullRoutes[i]));
      }
      continue;
    }

    routeItem = Object.assign({}, fullRoutes[i]);
    routeItem.menus = filterDisabledRoutes(routeItem.menus, allowedMenus, allowedMenusCode, noPowerVisible);

    if (!routeItem.menus) {
      if (routeItem.dynamicChild || routeItem.dynamic) {
        routeItem.menus = [];
      }
    }

    _fullRoutes.push(routeItem);
  }

  if (!_noPowerRoutes.length) return _fullRoutes;

  if (!_fullRoutes.length) return _noPowerRoutes;

  const lastRouteItem = _fullRoutes.pop();

  if (lastRouteItem.path === '/*' || lastRouteItem.path === '*') {
    _fullRoutes.push(..._noPowerRoutes, lastRouteItem);
  } else {
    _fullRoutes.push(lastRouteItem, ..._noPowerRoutes);
  }

  return _fullRoutes;
}

// filterDisabledRoutes([{ menuId: 1, path: '' }, { menuId: 2, path: '' }, { path: '' }], { menuId: 1 })

export function ToPage404() {
  return <Redirect to="/404" />;
}

// 为每个路由添加上兜底页面
export function addNotFoundRoute(menus) {
  if (!Array.isArray(menus)) return menus;

  if (menus.length === 0) return menus;

  // 如果只有一个路由/*不用添加最后兜底
  if (menus.length === 1 && menus[0].path === '/*') return menus;

  menus = menus.slice();

  let hasNotFoundPage = false;

  for (var i = 0, len = menus.length; i < len; i++) {
    if (menus[i].path === '*' || menus[i].path === '/*') hasNotFoundPage = true;

    menus[i].menus = addNotFoundRoute(menus[i].menus);
  }

  if (!hasNotFoundPage) {
    // path: * path: /* 都可以捕获未匹配路由
    menus.push({
      path: '/*',
      title: '404',
      hideInNav: true,
      component: ToPage404,
    });
  }

  return menus;
}

/**
 * 第一层级不需要添加兜底的path: ''
 * 加上之后的效果类似于path: '*'
 * 导致后面的路由都匹配不上
 */
export function addIndexRoute(routes) {
  if (!Array.isArray(routes)) return routes;
  routes = routes.slice();

  return addIndexRouteForSubRoute('', routes);
}

export function getLinkByPath(normalgetLink, { search, parentPath, path, relativePath }) {
  let to = '';
  if (normalgetLink) {
    to = normalgetLink({ search, parentPath, path, relativePath });
  } else {
    to =
      path.indexOf('?') === -1
        ? // 对于 /a/*的path在link上要变成/a/
          (path[path.length - 1] === '*' ? path.slice(0, path.length - 1) : path) + search
        : path;
  }

  return to;
}

// 有的没有默认路由，例如：
// [{path: 'a'}]
// 需要添加默认路由，重定向到第一个路由
// [{path: '', component: () => <Redirect to={path} />}, {path: 'a'}]
export function addIndexRouteForSubRoute(path, routes) {
  if (!Array.isArray(routes)) return routes;
  if (routes.length === 0) return routes;

  // 如果只有一个路由并且是*则不默认添加indexroute
  if (routes.length === 1 && routes[0].path === '/*') return routes;
  // 复制一份
  routes = routes.map((item) => Object.assign({}, item));
  let hasDefaultPath = false;

  for (var i = 0, len = routes.length; i < len; i++) {
    if (routes[i].path.trim() === '/') {
      hasDefaultPath = true;
    }

    routes[i].menus = addIndexRouteForSubRoute(path + routes[i].path, routes[i].menus);
  }

  if (!hasDefaultPath) {
    // _PathRedirectTo必须要在这里计算，
    // 如果是在组件内计算会出错，因为已经unshift了
    const _pathRedirectTo = getLinkByPath(routes[0].getLink, {
      parentPath: path,
      path: path + routes[0].path,
      relativePath: routes[0].path,
      search: '',
    });

    routes.unshift({
      path: '/',
      hideInNav: true,
      component: ({ match, location }) => {
        // window.location.search只能在这里添加，不能再上面_pathRedirectTop后面
        let to = matchParams(_pathRedirectTo, match);
        let [beforeHash, hash = ''] = to.split('#');
        hash = hash ? '#' + hash : hash;
        let [beforeSearch, search = ''] = beforeHash.split('?');
        search = search ? `?${search}` : '';

        to = beforeSearch + (search || location.search) + hash;
        return <Redirect to={to} />;
      },
    });
  }

  return routes;
}

// 重定向路由时，不会带路由中携带的param参数，需要手动替换
function matchParams(path, match) {
  if (!match || isEmpty(match.params)) return path;
  const { params } = match;

  Object.keys(params).forEach((item) => {
    path = path.replace(`:${item}`, params[item]);
  });

  return path;
}

/**
 * @param {[{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined}]} fullRoutesInState
 * @param {{parentId:string | number,menus:*}} newMenuItem
 * @param {[{menuId:x,menuCode:x,parentId:x,parentCode:x}]} fullRoutesInRouteConfig
 * @param {{[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *}} allowedMenus
 * @param {({[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *} | undefined)} [allowedMenusCode]
 */
export function installDynamicRoutes(
  fullRoutesInState,
  newMenuItem,
  fullRoutesInRouteConfig,
  allowedMenus,
  allowedMenusCode = {}
) {
  // 首先寻找父菜单
  for (var i = 0, len = fullRoutesInState.length; i < len; i++) {
    if (fullRoutesInState[i].menuId === newMenuItem.parentId || fullRoutesInState[i].menuCode === newMenuItem.parentId)
      break;
  }

  const parentMenu = fullRoutesInState[i];

  if (!parentMenu) {
    console.error('parrentId' + newMenuItem.parentId + '不存在');
    return fullRoutesInState;
  }

  // 子菜单安装过就直接返回
  const subMenuIsInstalled = parentMenu.menus && parentMenu.menus.length;

  if (subMenuIsInstalled) return fullRoutesInState;

  if (!allowedMenus /* 菜单权限接口还没有返回 */) return installRoutesBeforeMenusGeted();

  const allowedSubMenus = allowedMenus[parentMenu.menuId]?.menus || allowedMenusCode[parentMenu.menuCode]?.menus;

  if (!allowedSubMenus) return fullRoutesInState;

  return installRoutesAfterMenusGeted();

  function installRoutesAfterMenusGeted() {
    const copyParentMenu = Object.assign({}, parentMenu);
    copyParentMenu.menus = addIndexRouteForSubRoute(
      parentMenu.path,
      addNotFoundRoute(filterDisabledRoutes(newMenuItem.menus, allowedMenus, allowedMenusCode))
    );

    const newFullRoutesInState = fullRoutesInState.slice();

    newFullRoutesInState[i] = copyParentMenu;

    return newFullRoutesInState;
  }

  function installRoutesBeforeMenusGeted() {
    // 目前不会在菜单权限获取之前进来，因为拆分文件的加载必然在权限获取之后
    // 但是后面如果需要预加载拆分文件这里就很有必要
    const copyParentMenu = Object.assign({}, parentMenu);

    copyParentMenu.menus = newMenuItem.menus;

    const newFullRoutes = fullRoutesInRouteConfig.slice();

    newFullRoutes[i] = copyParentMenu;
    updateRoutes(newFullRoutes);

    return fullRoutesInState;
  }
}

/**
 *
 * @param {(string | number)} parentMenuId
 * @param {[{menuId:x,menuCode:x,parentId:x,parentCode:x}]} newSubMenus
 * @param {[{menuId:x,menuCode:x,parentId:x,parentCode:x}]} fullRoutesInState
 * @param {{[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *}} allowedMenus
 * @param {({[index: string]:{menuId:number | undefined,menuCode:string | undefined,parentId:number | undefined,parentCode:string | undefined} | *} | undefined)} allowedMenusCode
 * @returns
 */
// 更新指定父元素的childMenus
export function updateTargetMenu(parentMenuId, newSubMenus, fullRoutesInState, allowedMenus, allowedMenusCode) {
  const [pathToTargetValue, absolutePath] = deepSearchMenuTree(fullRoutesInState, parentMenuId);
  const allowedNewSubMenus = addIndexRouteForSubRoute(
    absolutePath.join(''),
    addNotFoundRoute(filterDisabledRoutes(newSubMenus, allowedMenus, allowedMenusCode))
  );

  // 在书树中到达目标值的路径
  const updateParam1 = {};

  pathToTargetValue.reduce((prev, cur, index, ar) => {
    // 是最后一个
    if (index === ar.length - 1) {
      prev[cur] = { $merge: { menus: allowedNewSubMenus } };
    } else {
      prev[cur] = {};
    }

    return prev[cur];
  }, updateParam1);

  return update(fullRoutesInState, updateParam1);

  function deepSearchMenuTree(fullMenus, targetMenuId) {
    const keyPath = [];
    const absolutePath = [];

    internelDeepSearch(fullMenus, targetMenuId);

    return [keyPath, absolutePath];

    function internelDeepSearch(fullMenus, targetMenuId) {
      for (var i = 0, len = fullMenus.length; i < len; i++) {
        keyPath.push(i);
        absolutePath.push(fullMenus[i].path);
        if (targetMenuId === fullMenus[i].menuId || targetMenuId === fullMenus[i].menuCode) return true;
        if (fullMenus[i].menus && fullMenus[i].menus.length) {
          keyPath.push('menus');
          if (internelDeepSearch(fullMenus[i].menus, targetMenuId)) return true;
          keyPath.pop();
        }
        keyPath.pop();
        absolutePath.pop();
      }
    }
  }
}

// console.log('zhou', updateTargetMenu(3012,
//   [{ menuId: 'zhang', path: '' }],
//   [
//     { menuId: 101 },
//     {
//       menuId: 301,
//       menus: [{ menuId: 1054 }, { menuId: 3012 }]
//     },
//     {
//       menuId: 1,
//       menus: [
//         { menuId: 90 },
//         {
//           menuId: 50,
//           menus: [
//             { menuId: 10 }
//           ]
//         }
//       ]
//     }, { menuId: 10 }, { menuId: 30 }, { menuId: 40 }
//   ],
//   { 301: true, zhang: true }
// ))

// 展开所有菜单栏，不能防止出现循环引用的情况
export function flatMenus(menus) {
  const res = {};

  _flatMenus(menus, res);

  return res;

  function _flatMenus(menus, res) {
    for (var i = 0, len = menus.length; i < len; i++) {
      if (menus[i].menuId) res[menus[i].menuId] = menus[i];

      if (menus[i].menus) {
        _flatMenus(menus[i].menus, res);
      }
    }
  }
}

// 根据menuIdCode得到map
export function flatMenusByCode(menus) {
  const res = {};

  _flatMenus(menus, res);

  return res;

  function _flatMenus(menus, res) {
    for (var i = 0, len = menus.length; i < len; i++) {
      if (menus[i].menuCode) res[menus[i].menuCode] = menus[i];

      if (menus[i].menus) {
        _flatMenus(menus[i].menus, res);
      }
    }
  }
}

// curRoute fullRoute
export function mergeDataTo(fromMenus, toMenus) {
  if (fromMenus.length === 0) return toMenus;
  const flattedFromMenus = flatMenus(fromMenus);
  const flattedFromMenusByCode = flatMenusByCode(fromMenus);

  return margeTo(toMenus);

  function margeTo(menus) {
    const res = [];
    let item;
    for (var i = 0, len = menus.length; i < len; i++) {
      item = menus[i];

      let childMenus = item.menus;
      // 如果自己有子路由用自己的
      if (item.menus && item.menus.length) {
        childMenus = margeTo(item.menus);
      } else {
        // 如果自己没有，看些别人有没有，有就用别人的
        if (flattedFromMenusByCode[item.menuCode] && flattedFromMenusByCode[item.menuCode].menus) {
          childMenus = flattedFromMenusByCode[item.menuCode].menus;
        } else if (flattedFromMenus[item.menuId] && flattedFromMenus[item.menuId].menus) {
          childMenus = flattedFromMenus[item.menuId].menus;
        }
      }

      res.push({ ...item, menus: childMenus });
    }

    return res;
  }
}

// console.log('111222', mergeDataTo([{ menuId: 1, menus: [{ a: 1 }] }], [{ menuId: 1 }]));
// console.log(
//   '111222',
//   mergeDataTo([{ menuId: 1, menus: [{ menus: [{ a: 1 }], menuId: 2 }] }], [{ menuId: 1, menus: [{ menuId: 2 }] }])
// );
// console.log(
//   '111222',
//   mergeDataTo(
//     [{ menuId: 1, menus: [{ menuId: 2, menus: [{ menuId: 3, menus: [{ a: 1 }] }] }] }],
//     [{ menuId: 1, menus: [{ menuId: 2, menus: [{ menuId: 3 }] }] }]
//   )
// );

// console.log('111222', mergeDataTo([{ menuId: 1, menus: [{ a: 1 }] }, { menuId: 2 }], [{ menuId: 1 }]));

// console.log('111222', mergeDataTo([{ menuId: 1, menus: [{ a: 1 }] }, { menuId: 2 }], [{ menuId: 1 }, { menuId: 3 }]));
